export const DEFAULT_APP_NAVBAR_HEIGHT = "3rem";

export const DEFAULT_APP_SIDEBAR_WIDTH = "14rem";

export const APP_NAVBAR_HEIGHT_CSS_VAR = "--app-navbar-height";

export const APP_SIDEBAR_WIDTH_CSS_VAR = "--app-sidebar-width";

export const APP_CONTENT_HEIGHT_CSS_VAR = "--app-content-height";

export const APP_CONTENT_WIDTH_CSS_VAR = "--app-content-width";

export const APP_FULL_HEIGHT_CONTENT_HEIGHT_CSS_VAR =
  "--app-full-height-content-height";

export const APP_NAVBAR_HEIGHT = `var(${APP_NAVBAR_HEIGHT_CSS_VAR})`;

export const APP_SIDEBAR_WIDTH = `var(${APP_SIDEBAR_WIDTH_CSS_VAR})`;

export const APP_CONTENT_HEIGHT = `var(${APP_CONTENT_HEIGHT_CSS_VAR})`;

export const APP_CONTENT_WIDTH = `var(${APP_CONTENT_WIDTH_CSS_VAR})`;

export const APP_FULL_HEIGHT_CONTENT_HEIGHT = `var(${APP_FULL_HEIGHT_CONTENT_HEIGHT_CSS_VAR}, ${APP_CONTENT_HEIGHT})`;

export function getAppContentHeightMinus(offset: string) {
  return `calc(${APP_CONTENT_HEIGHT} - ${offset})`;
}

export const APP_CONTENT_HEIGHT_PROPS = {
  height: APP_CONTENT_HEIGHT,
  mt: APP_NAVBAR_HEIGHT,
} as const;
